import styled from "styled-components";

const IconButtonStyled = styled.button`
    display: flex;
    position: relative;
    justify-content: center;
    font-size: ${({ fontSize }) => fontSize || '2rem'};
    background: ${({ $bg }) => $bg || 'transparent'};
    border: none;
    border-radius: 50%;
    padding: ${({$pad})=> $pad || '0'};
    cursor: pointer;
    color: ${({ color }) => color || '#fff'};
    span {
        position: absolute;
        top: -10px;
        right: -5px;

        display: flex;
        justify-content: center;
        align-items: center;

        width: 20px;   
        height: 20px;  
        border-radius: 50%;

        font-size: 0.75rem;
        font-weight: bold;
        background: ${({ $badgeBg }) => $badgeBg || '#5fbec5'};
        color: #fff;
    }    
`;

export default IconButtonStyled;